if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.artworkUpload = this.querySelector('[data-bjl-artwork-upload]');
        this.bindArtworkUpload();
      }

      bindArtworkUpload() {
        if (!this.artworkUpload) return;

        this.artworkOpen = this.artworkUpload.querySelector('[data-bjl-artwork-open]');
        this.artworkModal = this.artworkUpload.querySelector('[data-bjl-artwork-modal]');
        this.artworkStatus = this.artworkUpload.querySelector('[data-bjl-artwork-status]');
        this.artworkInstruction = this.artworkUpload.querySelector('[data-bjl-artwork-instruction]');
        this.artworkEmailLater = this.artworkUpload.querySelector('[data-bjl-artwork-email-later]');
        this.artworkEmailNote = this.querySelector('[data-bjl-artwork-email-note]');
        this.artworkSave = this.artworkUpload.querySelector('[data-bjl-artwork-save]');
        this.artworkCloseButtons = this.artworkUpload.querySelectorAll('[data-bjl-artwork-close]');
        this.artworkExtraFiles = this.artworkUpload.querySelector('[data-bjl-artwork-extra-files]');
        this.artworkAddFile = this.artworkUpload.querySelector('[data-bjl-add-file]');
        this.artworkDropzone = this.artworkUpload.querySelector('[data-bjl-dropzone]');
        this.artworkUploaded = this.artworkUpload.querySelector('[data-bjl-uploaded]');
        this.artworkNotes = this.artworkUpload.querySelector('[data-bjl-artwork-notes]');
        this.artworkFormId = this.artworkUpload.dataset.bjlProductFormId || this.form.id;
        this.artworkAcceptedFileTypes =
          this.artworkUpload.querySelector('[data-bjl-artwork-file]')?.getAttribute('accept') ||
          '.png,.jpg,.jpeg,.svg,.pdf,.ai,image/png,image/jpeg,image/svg+xml,application/pdf,application/postscript,application/illustrator';
        this.onArtworkKeydown = (event) => {
          if (event.key === 'Escape') this.closeArtworkModal();
        };
        this.refreshArtworkFileReferences();
        this.artworkNextFileIndex = Math.max(2, this.artworkFileInputs.length + 1);

        if (this.artworkModal && this.artworkModal.parentElement !== document.body) {
          document.body.appendChild(this.artworkModal);
        }

        this.artworkOpen?.addEventListener('click', () => this.openArtworkModal());
        this.artworkSave?.addEventListener('click', () => {
          this.updateArtworkSummary();
          this.closeArtworkModal();
        });
        this.artworkCloseButtons.forEach((button) => {
          button.addEventListener('click', () => this.closeArtworkModal());
        });
        this.artworkFileInputs.forEach((input) => {
          input.addEventListener('change', () => this.updateArtworkSummary());
        });
        this.artworkClearFileButtons.forEach((button) => {
          button.addEventListener('click', () => this.clearArtworkFile(button));
        });
        this.artworkAddFile?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.openNextArtworkFileInput();
        });
        this.artworkDropzone?.addEventListener('click', () => this.openNextArtworkFileInput());
        this.artworkDropzone?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          this.openNextArtworkFileInput();
        });
        this.artworkDropzone?.addEventListener('dragover', (event) => {
          event.preventDefault();
          this.artworkDropzone.classList.add('is-dragging');
        });
        this.artworkDropzone?.addEventListener('dragleave', () => {
          this.artworkDropzone.classList.remove('is-dragging');
        });
        this.artworkDropzone?.addEventListener('drop', (event) => {
          event.preventDefault();
          this.artworkDropzone.classList.remove('is-dragging');
          this.addArtworkFiles(event.dataTransfer?.files);
        });

        this.updateArtworkSummary();
      }

      refreshArtworkFileReferences() {
        const artworkRoot = this.artworkModal || this.artworkUpload;

        this.artworkFileInputs = artworkRoot.querySelectorAll('[data-bjl-artwork-file]');
        this.artworkFileLabels = artworkRoot.querySelectorAll('[data-bjl-file-name]');
        this.artworkFileSizeLabels = artworkRoot.querySelectorAll('[data-bjl-file-size]');
        this.artworkOriginalNameInputs = artworkRoot.querySelectorAll('[data-bjl-original-file-name]');
        this.artworkFileRows = artworkRoot.querySelectorAll('[data-bjl-file-row]');
        this.artworkClearFileButtons = artworkRoot.querySelectorAll('[data-bjl-clear-file]');
      }

      createArtworkFileRow(index) {
        const wrapper = document.createElement('div');
        const input = document.createElement('input');
        const originalName = document.createElement('input');
        const icon = document.createElement('span');
        const meta = document.createElement('span');
        const fileName = document.createElement('strong');
        const fileSize = document.createElement('small');
        const removeButton = document.createElement('button');

        wrapper.className = 'bjl-artwork-file-row';
        wrapper.setAttribute('data-bjl-file-row', '');
        wrapper.hidden = true;

        input.id = `${this.artworkFormId}-additional-file-${index}`;
        input.className = 'bjl-artwork-file__input';
        input.type = 'file';
        input.setAttribute('form', this.artworkFormId);
        input.name = `properties[Additional uploaded file ${index}]`;
        input.accept = this.artworkAcceptedFileTypes;
        input.setAttribute('data-bjl-artwork-file', '');

        originalName.type = 'hidden';
        originalName.setAttribute('form', this.artworkFormId);
        originalName.name = `properties[Original uploaded file name ${index}]`;
        originalName.setAttribute('data-bjl-original-file-name', '');
        originalName.disabled = true;

        icon.className = 'bjl-artwork-file-row__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v5h5"></path><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"></path></svg>';

        meta.className = 'bjl-artwork-file-row__meta';

        fileName.setAttribute('data-bjl-file-name', '');
        fileName.textContent = 'No file selected';

        fileSize.setAttribute('data-bjl-file-size', '');

        removeButton.type = 'button';
        removeButton.className = 'bjl-artwork-remove-file';
        removeButton.setAttribute('data-bjl-clear-file', '');
        removeButton.setAttribute('aria-label', 'Remove file');
        removeButton.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';

        meta.append(fileName, fileSize);
        wrapper.append(input, originalName, icon, meta, removeButton);

        input.addEventListener('change', () => this.updateArtworkSummary());
        removeButton.addEventListener('click', () => this.clearArtworkFile(removeButton));

        return { input, wrapper };
      }

      addArtworkFileRow() {
        if (!this.artworkExtraFiles) return null;

        const fileIndex = this.artworkNextFileIndex;
        const { input, wrapper } = this.createArtworkFileRow(fileIndex);
        this.artworkNextFileIndex += 1;
        this.artworkExtraFiles.appendChild(wrapper);
        this.refreshArtworkFileReferences();
        this.updateArtworkSummary();

        return input;
      }

      getAvailableArtworkFileInput() {
        this.refreshArtworkFileReferences();

        return (
          Array.from(this.artworkFileInputs).find((input) => !input.files || !input.files.length) ||
          this.addArtworkFileRow()
        );
      }

      openNextArtworkFileInput() {
        const nextInput = this.getAvailableArtworkFileInput();

        nextInput?.click();
      }

      addArtworkFiles(files) {
        if (!files || !files.length) return;

        Array.from(files).forEach((file) => {
          const input = this.getAvailableArtworkFileInput();
          if (!input || typeof DataTransfer === 'undefined') return;

          const fileTransfer = new DataTransfer();
          fileTransfer.items.add(file);
          input.files = fileTransfer.files;
        });

        this.updateArtworkSummary();
      }

      clearArtworkFile(button) {
        const row = button.closest('[data-bjl-file-row]');
        const input = row?.querySelector('[data-bjl-artwork-file]');

        if (!row || !input) return;

        input.value = '';

        if (!row.hasAttribute('data-bjl-primary-file-row')) {
          row.remove();
        }

        this.refreshArtworkFileReferences();
        this.updateArtworkSummary();
        this.artworkDropzone?.focus({ preventScroll: true });
      }

      formatArtworkFileSize(bytes) {
        if (!bytes) return '';

        if (bytes < 1024 * 1024) {
          return `${Math.max(1, Math.round(bytes / 1024))} KB`;
        }

        return `${(bytes / 1024 / 1024).toFixed(1).replace('.0', '')} MB`;
      }

      openArtworkModal() {
        if (!this.artworkModal) return;

        this.artworkModal.hidden = false;
        this.artworkOpen?.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onArtworkKeydown);
        window.setTimeout(() => {
          this.artworkModal.querySelector('[data-bjl-artwork-close]')?.focus();
        }, 0);
      }

      closeArtworkModal() {
        if (!this.artworkModal) return;

        this.artworkModal.hidden = true;
        this.artworkOpen?.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onArtworkKeydown);
        this.artworkOpen?.focus({ preventScroll: true });
      }

      getArtworkFileNames() {
        this.refreshArtworkFileReferences();
        if (!this.artworkFileInputs) return [];

        return Array.from(this.artworkFileInputs)
          .filter((input) => input.files && input.files.length)
          .map((input) => input.files[0].name);
      }

      hasArtworkChoice() {
        return this.getArtworkFileNames().length > 0;
      }

      updateArtworkSummary() {
        if (!this.artworkUpload) return;

        this.refreshArtworkFileReferences();
        const fileNames = this.getArtworkFileNames();

        this.artworkFileInputs.forEach((input, index) => {
          const file = input.files?.[0];
          const fileName = file?.name || '';

          if (this.artworkFileLabels[index]) {
            this.artworkFileLabels[index].textContent = fileName || 'No file selected';
          }

          if (this.artworkFileSizeLabels[index]) {
            this.artworkFileSizeLabels[index].textContent = file ? this.formatArtworkFileSize(file.size) : '';
          }

          if (this.artworkOriginalNameInputs[index]) {
            this.artworkOriginalNameInputs[index].value = fileName;
            this.artworkOriginalNameInputs[index].disabled = !file;
          }

          if (this.artworkFileRows[index]) {
            this.artworkFileRows[index].hidden = !file;
          }
        });

        if (this.artworkUploaded) {
          this.artworkUploaded.hidden = fileNames.length === 0;
        }

        if (fileNames.length) {
          this.artworkStatus.textContent = fileNames.join(', ');
        } else {
          this.artworkStatus.textContent = 'Upload now, or send files after ordering.';
        }

        if (this.artworkInstruction) {
          this.artworkInstruction.value = fileNames.length
            ? 'Upload files with order'
            : 'Customer will send files separately';
        }

        if (this.artworkEmailLater) {
          this.artworkEmailLater.disabled = fileNames.length > 0;
        }

        if (fileNames.length) {
          this.hideArtworkEmailNote();
        }

        this.artworkUpload.classList.toggle('has-artwork', fileNames.length > 0);
      }

      showArtworkEmailNote() {
        if (!this.artworkEmailNote) return;

        this.artworkEmailNote.hidden = false;
      }

      hideArtworkEmailNote() {
        if (!this.artworkEmailNote) return;

        this.artworkEmailNote.hidden = true;
      }

      prepareArtworkProperties() {
        if (!this.artworkUpload) return;

        this.updateArtworkSummary();

        if (this.artworkNotes) {
          this.artworkNotes.disabled = this.artworkNotes.value.trim() === '';
        }
      }

      onSubmitHandler(evt) {
        this.prepareArtworkProperties();

        const hasSelectedFileUpload = Array.from(
          this.form.querySelectorAll('input[type="file"][name^="properties["]')
        ).some((input) => input.files && input.files.length);

        if (hasSelectedFileUpload) return;

        if (this.artworkUpload && !this.hasArtworkChoice()) {
          this.showArtworkEmailNote();
        }

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (!hasSelectedFileUpload) {
          this.form.querySelectorAll('input[type="file"][name^="properties["]').forEach((input) => {
            formData.delete(input.name);
          });
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
